import { Account, Person, Order } from '../schema/accountSchema'
import { generateAccountPeople } from './enhancedPeopleGenerator'
function generateOrders(accountId: string): Order[] {
  const orderTitles = [
    'Q1 Direct Mail Campaign',
    'Brand Refresh Package',
    'Holiday Catalog Production',
    'Digital Asset Library',
    'Store Signage Rollout',
    'Product Launch Materials',
    'Annual Report Design',
    'Seasonal Promotion Kit',
    'Corporate Brochure Update',
    'Trade Show Materials',
  ]
  const statuses: Array<'In Progress' | 'Delivered' | 'On Hold' | 'Planning'> =
    ['In Progress', 'Delivered', 'On Hold', 'Planning']
  const orders: Order[] = []
  const numOrders = 3 + Math.floor(Math.random() * 3)
  for (let i = 0; i < numOrders; i++) {
    const daysAgo = Math.floor(Math.random() * 60)
    const date = new Date()
    date.setDate(date.getDate() - daysAgo)
    orders.push({
      id: `${accountId}-order-${i + 1}`,
      title: orderTitles[Math.floor(Math.random() * orderTitles.length)],
      status: statuses[Math.floor(Math.random() * statuses.length)],
      value: 25000 + Math.floor(Math.random() * 1175000),
      date: date.toISOString(),
    })
  }
  return orders
}
export function ensureAccountPeople(account: Account): Account {
  const hasClientContacts =
    account.client_contacts && account.client_contacts.length >= 7
  const hasQuadTeam = account.quad_team && account.quad_team.length >= 5
  let client_contacts = account.client_contacts || []
  let quad_team = account.quad_team || []
  if (!hasClientContacts || !hasQuadTeam) {
    const generated = generateAccountPeople(account.id, account.name)
    client_contacts = generated.client_contacts
    quad_team = generated.quad_team
  }
  const orders =
    account.orders && account.orders.length > 0
      ? account.orders
      : generateOrders(account.id)
  return {
    ...account,
    client_contacts,
    quad_team,
    people: [...client_contacts, ...quad_team],
    orders,
    status: account.status || 'Active',
    margin_health: account.margin_health || 'Healthy',
    last_activity: account.last_activity || account.last_sync,
  }
}
export function ensureAllAccountsPeople(accounts: Account[]): Account[] {
  return accounts.map(ensureAccountPeople)
}
